/**
 * 全局错误码-中文描述
 * main.js 引入;
 * Vue.use(CodePlugin)
 * 使用 this.$showCodeMsg(code)
 */
import msgCode from './zh-cn/error-code.js';

// 获取code对应msg
const getMsg = (code)=>{
    return msgCode[code] || code || '未知错误'; //默认“未知错误”
};

const plugin = {
    install(vue) {
        const showCodeMsg = (code) => {
            if(code){
                vue.$vux.toast.show({
                    text: getMsg(code)
                });
            }
        };
        vue.prototype.$showCodeMsg = showCodeMsg;
    }
};

export default plugin;
export const install = plugin.install;
